import { render, staticRenderFns } from "./IndicatorValue.vue?vue&type=template&id=3c6ba06d"
import script from "./IndicatorValue.vue?vue&type=script&lang=js"
export * from "./IndicatorValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports